var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.1 63.5",
    style: {
      enableBackground: "new 0 0 200.1 63.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCD8F6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.6,1.1l-34.1,61.7L85,1.1h8l26.5,47.3l22.3-40.3h-10.3l-12.8,23.7l-4-7.2l12.7-23.5H153.6z M47,62.8h26.3 l6-11.1h14.5l-4.3-7h-6.4l2.9-5.4l-4-7.2L69.1,55.8H58.8l22.3-40.3l26.5,47.3h8L81.1,1.1L47,62.8z M168.5,15.1l9.3,16.8l-9.3,16.8 h-7.9l9.3-16.9l-9.3-16.7H168.5z M171.1,1.1l16.7,30.9l-16.7,30.8h7.9l16.7-30.9L179.1,1.1H171.1z M39.8,15.1l-9.3,16.7l9.3,16.9 h-7.9l-9.3-16.8l9.3-16.8H39.8z M21.3,1.1L4.5,31.8l16.7,30.9h7.9L12.5,31.9L29.2,1.1H21.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d7ee1ca6002418abbf62b2605486bd84.svg";
export { ForwardRef as ReactComponent };